import styled from "styled-components";

export const VerticalDivider = styled.div<{ heightCssValue?: string }>`
    height: ${(props) => props.heightCssValue ?? `80%`};
    width: 1px;
    border-left: 1px solid ${(props) => props.theme.borderPrimary};
`;

export const HorizontalDivider = styled.div<{ widthCssValue?: string }>`
    height: 1px;
    width: ${(props) => props.widthCssValue ?? `80%`};
    border-top: 1px solid ${(props) => props.theme.borderPrimary};
`;
